import {
  RenderCreateFormButton,
  RenderHelper,
  RenderUnit,
} from "../../../../human-organization/summary-employee-request/utils/render-helper";
import { Box } from "../../../../../../components";
import { formFields1, formFields2 } from "../../constant/field-names";
import { Form, Row, Skeleton } from "antd";
import { useState } from "react";
import { PATH } from "../../constant/path";
import { useHistory, useRouteMatch } from "react-router-dom";
import { CreateNotification } from "../../../../../../components/notifier";
import { MeetingRequestService } from "../../../../../../services/company-office/MeetingRequest.service";
import { useEffect } from "react";
import moment from "moment";

export function EditForm() {
  const [form] = Form.useForm();
  const [department, setDepartment] = useState("");
  const { id } = useRouteMatch().params as any;
  const [isLoading, setIsLoading] = useState(false);

  const onValuesChange = (changedValues: any, allValues: any) => {
    if (changedValues.eDepartment) {
      setDepartment(changedValues.eDepartment);
    }
  };

  const initData = async () => {
    setIsLoading(true);
    const data = await MeetingRequestService.getMeetingRequest(id);
   

    let initForm: any = {};

    for (const field of formFields1) {
      initForm[field.field] = data.fields[field.field];
    }

    for (const field of formFields2) {
      initForm[field.field] = data.fields[field.field];
    }

    initForm["eUnit"] = data.fields["eUnit"];
    initForm["eMeetingTime"] = initForm["eMeetingTime"]
      ? moment(initForm["eMeetingTime"])
      : moment();

    form.setFieldsValue(initForm);
    setDepartment(data.fields["eDepartment"]);

    setIsLoading(false);
  };

  useEffect(() => {
    initData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const history = useHistory();

  const onFinish = async (values: any) => {
    try {
      let initForm: any = {};

      for (const field of formFields1) {
        initForm[field.field] = values[field.field];
      }

      for (const field of formFields2) {
        initForm[field.field] = values[field.field];
      }

      initForm["eUnit"] = values["eUnit"];

      await MeetingRequestService.updateMeetingRequest(
        id,
        initForm
      );

      CreateNotification({
        title: "Thành công",
        body: "Sửa yêu cầu thành công",
        icon: "/icons/success.png",
      });

      history.push(PATH.HOME);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Chỉnh sửa yêu cầu thất bại`,
        icon: "/icons/error.png",
      });
      history.push(PATH.HOME);
    }
  };

  if (isLoading) return <Skeleton />;

  return (
    <>
      <Form
        size="large"
        onFinish={onFinish}
        form={form}
        onValuesChange={onValuesChange}
      >
        <Box title="Thông tin">
          <Row gutter={[32, 0]}>
            <RenderHelper fields={formFields1} mode={"edit"} />
            {!isLoading && (
              <RenderUnit
                department={department}
                form={form}
                span={8}
                mode={"edit"}
              />
            )}
          </Row>
        </Box>

        <Box title="Thông tin chi tiết">
          <Row gutter={[32, 0]}>
            <RenderHelper fields={formFields2} />
            {/* <RenderApprover department={department} form={form} /> */}
            <RenderCreateFormButton homePath={PATH.HOME} />
          </Row>
        </Box>
      </Form>
    </>
  );
}
